export const CatalogText = () => {}
